import { render, staticRenderFns } from "./FormHistoryOffcanvas.vue?vue&type=template&id=326b425b"
import script from "./FormHistoryOffcanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./FormHistoryOffcanvas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports